module.exports = __webpack_public_path__ + "img/loginlogo.b25fcab6.png";